import axios from 'axios';
import { config } from '@ibk/shared-config';
import { ChannelEnum, DeviceTypeEnum, TemplateEnum } from '@ibk/shared-types';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
import { isDeviceNotFoundError } from './deviceErrorHandler';
import { getBrowserInfo, getPublicKey } from './deviceHelpers';
import { getDeviceIdFromSession, saveRegisteredDevice } from './deviceStorage';
export async function saveDeviceApi(channelSent, personId) {
    try {
        const publicKey = await getPublicKey();
        const { browserName, osName, osVersion } = getBrowserInfo();
        const deviceProps = {
            type: DeviceTypeEnum.phone,
            publicKey,
            make: osName,
            model: browserName,
            osVersion,
            personId,
            channel: channelSent === 'email' ? ChannelEnum.email : ChannelEnum.phone,
            templateId: TemplateEnum.VALIDATION_TOKEN_TEMPLATE,
        };
        const response = await axios.post(`${config.apiBaseUrl}/v1/onboarding/register-device`, deviceProps, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const result = response.data;
        if (result.result?.id) {
            await saveRegisteredDevice(personId, result.result.id, false);
        }
        return result.result;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const errorData = error.response?.data || {};
            const errorMessage = new Error(errorData.message || 'Erro ao salvar dispositivo');
            if (isDeviceNotFoundError(errorMessage)) {
                throw new Error('DEVICE_NOT_FOUND');
            }
            throw errorMessage;
        }
        throw error;
    }
}
export async function validateDeviceApi(token, personId) {
    try {
        const deviceId = getDeviceIdFromSession();
        if (!deviceId) {
            throw new Error('No device ID found');
        }
        const response = await axios.post(`${config.apiBaseUrl}/v1/onboarding/token-validation`, {
            token,
            deviceId,
            personId,
            templateId: TemplateEnum.VALIDATION_TOKEN_TEMPLATE,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const result = response.data;
        if (result.result) {
            await saveRegisteredDevice(personId, deviceId, true);
        }
        return result.result;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const errorData = error.response?.data || {};
            const errorMessage = new Error(errorData.message || 'Token inválido ou expirado');
            if (isDeviceNotFoundError(errorMessage)) {
                throw new Error('DEVICE_NOT_FOUND');
            }
            throw errorMessage;
        }
        throw error;
    }
}
export async function resendDeviceTokenApi(channel, personId, deviceId) {
    try {
        const token = localStorageService.getItemSync(StorageKeys.AuthToken);
        const response = await axios.post(`${config.apiBaseUrl}/v1/onboarding/resend-token`, {
            channel,
            personId,
            deviceId,
            templateId: TemplateEnum.VALIDATION_TOKEN_TEMPLATE,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'device-id': deviceId,
                authorization: `Bearer ${token}`,
            },
        });
        return response.data.result;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error('Erro ao reenviar token');
        }
        throw error;
    }
}
